import React from 'react';
import { selectIsComplexWorkflowRoutingIslandOpen, selectWorkflowRoutingActions } from 'flow/store/redux/selectors';
import { useAppSelector } from '~/store/reduxHooks';
import { sortWorkflowRoutingActionsByPrecedenceIndex } from '~/dashboard/views/workflows/service/actions';
import ComplexWorkflowRoutingIsland from './ComplexWorkflowRoutingIsland';
import SimpleWorkflowRoutingIsland from './SimpleWorkflowRoutingIsland';


export default function WorkflowRoutingIsland() {
  const workflowRoutingActions = useAppSelector(selectWorkflowRoutingActions);
  const isComplexIslandOpen = useAppSelector(selectIsComplexWorkflowRoutingIslandOpen);

  const Island = isComplexIslandOpen ? ComplexWorkflowRoutingIsland : SimpleWorkflowRoutingIsland;

  const sortedWorkflowRoutingActions = React.useMemo(
    () => sortWorkflowRoutingActionsByPrecedenceIndex(workflowRoutingActions),
    [workflowRoutingActions]);

  return (
    <Island workflowRoutingActions={sortedWorkflowRoutingActions} />
  );
}
